import { defineComponent as _defineComponent } from 'vue'
import {
  formatDateTime,
  formatDurationAsHours,
  formatTimeRange,
} from '@/utils/date-formatting.js'
import JobStatusChip from '@/components/tickets/JobStatusChip.vue'
import { NO_APPROVAL } from '@/models/job'
import JobCardLocationsDetail from '../jobs/JobCardLocationsDetail.vue'
import moment from 'moment'
import { computed } from 'vue'
import { Item } from '@/components/weekly-schedule/utils'
import { useStore } from 'vuex-composition-helpers'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventJobDetailsCard',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as { item: Item }


const store = useStore()

const company = computed(() =>
  store.getters['companies/getByChildHubId'](props.item?.hubId)
)
const formatDetails = computed(() => {
  if (props.item.details.length > 150) {
    return props.item.details.slice(0, 150) + '...'
  }
  return props.item.details
})
const customerName = computed(
  () => props.item.customer && props.item.customer.name
)
const showActualTimes = computed(
  () => props.item.activeTime || props.item.completedTime
)
const showActiveDuration = computed(
  () => props.item.actualActiveDuration >= moment.duration(0.01, 'hours')
)
const showPausedDuration = computed(
  () => props.item.pausedDuration >= moment.duration(0.01, 'hours')
)
const formatPlannedTime = computed(() =>
  formatTimeRange(props.item.startTime, props.item.endTime)
)
const formatActualTime = computed(() => {
  if (!props.item.completedTime) {
    return formatTimeRange(
      props.item.activeTime,
      props.item.completedTime,
      '-',
      'Ongoing'
    )
  }

  if (!props.item.activeTime) {
    return `${formatDateTime(props.item.completedTime)}`
  }

  const activeMinute = moment(props.item.activeTime).startOf('minute')
  const completedMinute = moment(props.item.completedTime).startOf('minute')

  if (activeMinute.isSame(completedMinute)) {
    return `${formatDateTime(props.item.completedTime)}`
  }

  return formatTimeRange(props.item.activeTime, props.item.completedTime)
})
const formatHoursForActiveDuration = computed(() =>
  formatDurationAsHours(props.item.actualActiveDuration, true)
)
const formatHoursForPausedDuration = computed(() =>
  formatDurationAsHours(props.item.pausedDuration, false)
)
const finalStatus = (job: Item) =>
  job.approvalStatus !== NO_APPROVAL ? job.approvalStatus : job.status

return { __sfc: true,props, store, company, formatDetails, customerName, showActualTimes, showActiveDuration, showPausedDuration, formatPlannedTime, formatActualTime, formatHoursForActiveDuration, formatHoursForPausedDuration, finalStatus, JobStatusChip, JobCardLocationsDetail }
}

})